import { defineMessages } from "react-intl";

const messages = defineMessages({
    homework: {
        id: "homework",
    },
    total: {
        id: "homework.total",
    },
    noSolutionYet: {
        id: "homework.noSolutionYet",
    },
    step0: {
        id: "homework.steps.0",
    },
    step1: {
        id: "homework.steps.1",
    },
    step2: {
        id: "homework.steps.2",
    },
    step3: {
        id: "homework.steps.3",
    },
    noFacebook: {
        id: "homework.steps.noFacebook",
    },
    or: {
        id: "general.or",
    },
    postNote: {
        id: "homework.steps.app.post",
    },
    appStep1a: {
        id: "join.modal.app.1",
    },
    appStep1b: {
        id: "homework.steps.app.1.b",
    },
});

export default messages;
